var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',{attrs:{"data-identifier":_vm.identifier,"type":"bar","height":_vm.chartHeight,"width":_vm.chartWidth,"options":_vm.options,"series":_vm.series},on:{"click":_vm.chartClickEvent}})}
var staticRenderFns = []

export { render, staticRenderFns }